import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ACTIONS } from '../actions/actionTypes';

class MissionTestView extends Component {
    constructor (props) {
        super(props);
        this.renderMissionList = this.renderMissionList.bind(this);
    }
    componentDidMount () {
        this.props.getMissions();
    }

    renderMissionList () {
        if (this.props.missions) {
            return this.props.missions.map((item, index) => {
                let area = AREAS[Math.floor(Math.random() * AREAS.length)];
                let object = {
                    user: this.props.user._id,
                    mission: item,
                    area
                };
                console.log(object);
                return (
                    <div key={index} style={{flexDirection: 'row'}} >
                        <span>{item.title} </span>
                        <span onClick={() => this.props.dispatchMission(object)}>testar</span>
                    </div>
                );
            });
        }
    }
    render () {
        console.log(this.props);
        return (
            <div className='view-background browser'>
                {this.renderMissionList()}
            </div>

        );
    }
}

const mapStateToProps = (state) => ({
    missions: state.missionReducer.missions,
    user: state.user.user
});

const mapActionsToProps = (dispatch) => ({
    getMissions: () => dispatch({type: ACTIONS.GET_MISSIONS}),
    dispatchMission: (mission) => dispatch({type: ACTIONS.DISPATCH_MISSION, payload: mission})
});

export default connect(mapStateToProps, mapActionsToProps)(MissionTestView)
;
const AREAS = [{
    "_id": "5995a04b6294c00011793593",
    "updated_at": "2017-08-18T13:32:51.783Z",
    "created_at": "2017-08-17T13:55:23.730Z",
    "title": "Ciências Exatas e da Terra",
    "deleted": false,
    "__v": 0
},
{
    "_id": "5996eb117c6cdb001114d452",
    "updated_at": "2017-08-18T13:26:41.679Z",
    "created_at": "2017-08-18T13:26:41.679Z",
    "title": "Ciências Humanas",
    "deleted": false,
    "__v": 0
},
{
    "_id": "5996eca07c6cdb001114d453",
    "updated_at": "2017-08-18T13:33:20.696Z",
    "created_at": "2017-08-18T13:33:20.696Z",
    "title": "Ciências Sociais Aplicadas",
    "deleted": false,
    "__v": 0
},
{
    "_id": "5996ecb37c6cdb001114d454",
    "updated_at": "2017-08-18T13:33:39.180Z",
    "created_at": "2017-08-18T13:33:39.180Z",
    "title": "Ciências Biológicas",
    "deleted": false,
    "__v": 0
},
{
    "_id": "5996ecc87c6cdb001114d455",
    "updated_at": "2017-08-18T13:34:00.521Z",
    "created_at": "2017-08-18T13:34:00.521Z",
    "title": "Ciências da Saúde",
    "deleted": false,
    "__v": 0
},
{
    "_id": "5996ecdb7c6cdb001114d456",
    "updated_at": "2017-09-13T13:57:15.537Z",
    "created_at": "2017-08-18T13:34:19.502Z",
    "title": "Engenharias",
    "deleted": false,
    "__v": 0
},
{
    "_id": "5996ecf87c6cdb001114d457",
    "updated_at": "2017-08-18T13:34:58.066Z",
    "created_at": "2017-08-18T13:34:48.673Z",
    "title": "Linguística, Letras e Artes",
    "deleted": false,
    "__v": 0
},
{
    "_id": "5996ed0f7c6cdb001114d458",
    "updated_at": "2017-08-18T13:35:11.338Z",
    "created_at": "2017-08-18T13:35:11.338Z",
    "title": "Multidisciplinar",
    "deleted": false,
    "__v": 0
},
{
    "_id": "59ad697c0a234300113785f3",
    "updated_at": "2017-09-04T14:55:56.667Z",
    "created_at": "2017-09-04T14:55:56.667Z",
    "title": "Enem",
    "deleted": false,
    "__v": 0
}];



// WEBPACK FOOTER //
// ./src/views/missionTestView.js